import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard } from './auth/auth.guard';
import { LoginComponent } from './login/login.component';
import { PasswordChangeComponent } from './password-change/password-change.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';
import { MaintenanceComponent } from './maintenance/maintenance.component';
import { LpComponent } from './lp/lp.component';
import { Constant } from './constant';
import { MyEventComponent } from './my-event/my-event.component';
import { MyEventDetailComponent } from './my-event-detail/my-event-detail.component';
import { SignUpComponent } from './sign-up/sign-up.component';
import { OrgAccountComponent } from './organization-account/organization-account.component';
import { OrgAboutComponent } from './organization-about/organization-about.component';
import { AccountAboutComponent } from './account-about/account-about.component';
import { MasterSettingsComponent } from './master-settings/master-settings.component';
import { PageAccessDeniedComponent } from './page-access-denied/page-access-denied.component';
import { UnionConsultationComponent } from './union-consultation/union-consultation.component';
import { UnionConsultationEditComponent } from './union-consultation-edit/union-consultation-edit.component';
import {TermsComponent } from './terms/terms.component';
import {PrivacyComponent } from './privacy/privacy.component';
import { EventSearchComponent } from './event-search/event-search.component';
import { EventDetailComponent } from './event-detail/event-detail.component';
import { AttendanceParticipantComponent } from './attendance-participant/attendance-participant.component';
import { AttendanceManagementComponent } from './attendance-management/attendance-management.component';
import { AttendanceQrPosterComponent } from './attendance-qr-poster/attendance-qr-poster.component';
import { EventOperationHubComponent } from './event-operation-hub/event-operation-hub.component';
import { GuestAttendanceManagementComponent } from './guest-attendance/guest-attendance-management.component';
import { EventSurveyParticipantComponent } from './event-survey/event-survey-participant.component';
import { EventSurveyManagementComponent } from './event-survey/event-survey-management.component';
import { GuestRegistrationComponent } from './guest-attendance/guest-registration.component';

const routes: Routes = [
  { path: 'login/:code', component: LoginComponent },
  { path: 'login', redirectTo: '/' },
  { path: 'password_change', component: PasswordChangeComponent },
  { path: 'signup/:code', component: SignUpComponent },
  { path: 'myevent', component: MyEventComponent, canActivate: [AuthGuard], data: { minAuth: 3 }},
  { path: 'myevent/approval', component: MyEventComponent, canActivate: [AuthGuard], data: { minAuth: 3 }},
  { path: 'myevent-detail/:id', component: MyEventDetailComponent, canActivate: [AuthGuard], data: { minAuth: 3 }},
  { path: 'myevent-detail/:id/attendance', component: AttendanceManagementComponent, canActivate: [AuthGuard] },
  { path: 'myevent-detail/:id/attendance/qr-poster', component: AttendanceQrPosterComponent, canActivate: [AuthGuard] },
  { path: 'myevent-operation/:id', component: EventOperationHubComponent, canActivate: [AuthGuard] },
  { path: 'myevent-operation/:id/guest-attendance', component: GuestAttendanceManagementComponent, canActivate: [AuthGuard], canDeactivate: [(component: GuestAttendanceManagementComponent) => component.canDeactivate()] },
  { path: 'myevent-operation/:id/survey', component: EventSurveyManagementComponent, canActivate: [AuthGuard] },
  { path: 'event-survey/:token', component: EventSurveyParticipantComponent },
  { path: 'guest/register/:token', component: GuestRegistrationComponent },
  { path: 'guest/manage/:token', component: GuestRegistrationComponent },
  { path: 'attendance/:code/:id', component: AttendanceParticipantComponent, canActivate: [AuthGuard] },
  { path: 'event/:id', component: EventDetailComponent, canActivate: [AuthGuard], data: { minAuth: 3 }},
  { path: 'ex-event/:id', component: EventDetailComponent, canActivate: [AuthGuard], data: { minAuth: 3 }},
  { path: 'union-consultation', component: UnionConsultationComponent, canActivate: [AuthGuard], data: { minAuth: 3 }},
  { path: 'union-consultation/:id', component: UnionConsultationEditComponent, canActivate: [AuthGuard], data: { minAuth: 3 }},
  { path: 'event-search', component: EventSearchComponent, canActivate: [AuthGuard], data: { minAuth: 3 }},
  // アカウント管理は権限 2 以上
  {
    path: 'account',
    component: OrgAccountComponent,
    canActivate: [AuthGuard],
    data: { minAuth: 2 }
  },
  // 組織情報・マスタ設定は権限 1 以上
  {
    path: 'overview',
    component: OrgAboutComponent,
    canActivate: [AuthGuard],
    data: { minAuth: 1 }
  },
  { path: 'profile', component: AccountAboutComponent, canActivate: [AuthGuard] },
  {
    path: 'master',
    component: MasterSettingsComponent,
    canActivate: [AuthGuard],
    data: { minAuth: 1 }
  },
  { path: 'terms', component: TermsComponent },
  { path: 'privacy', component: PrivacyComponent },
  // 権限不足時の画面
  { path: 'access-denied', component: PageAccessDeniedComponent },
  { path: '', component: LpComponent },
  { path: 'error', component: PageNotFoundComponent },
  { path: 'maintenance', component: MaintenanceComponent },
  { path: '**', redirectTo: '/error' }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes),
    MyEventComponent,
    MyEventDetailComponent,
    UnionConsultationComponent,
    UnionConsultationEditComponent,
    EventDetailComponent
  ],
  exports: [RouterModule]
})
export class AppRoutingModule {}
